import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white z-40 rounded-3xl overflow-hidden shadow-2xl -mt-20 h-44 w-2/5 flex justify-center items-center fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}